module.exports = __webpack_public_path__ + "fonts/f1bc8267-a817-408b-a089-4310761881f7.9fb79129.eot";